import TiptapTableRow from '@tiptap/extension-table-row';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TableRow = TiptapTableRow.extend({
  allowGapCursor: false,
  content: '(tableCell|tableHeader)*',
  draggable: false,
});
